export const INTRODUCTION = `I'm a techno freak, I love working with updated tech out there.
              When you look at my background of being an Electronics guy,
              beaware because that tag can fool you, I love mingling with
              Computer Science, love to code and develop projects intriguing for
              me as well! Passion for foreign languages is also another story
              especially Japanese. Professionally, I'm Working with Birlasoft as
              a Java Developer!`;
